import React, { useEffect, useState } from 'react';
import Loading from 'components/loading';
import LoanInfo from 'components/loan-info';
import Title from 'components/title';
import { useCouponByLoanLazyQuery, useGetLoanQuery } from 'generated/graphql';
import { IDiscountCalculated } from 'interfaces/interfaces';
import { calculateDiscounts, hasComissionDiscount, hasDiscountsToApply } from 'utils/discount-utils';
import { getLoanApplicationParams } from 'utils/utils';

const SummaryPage: React.FC = () => {
    const  loanApplicationId  = getLoanApplicationParams();

    const [discountCalculated, setDiscountCalculated] = useState<IDiscountCalculated>({});
    const [discounts, setDiscounts] = useState([]);
    const [couponByLoanQuery] = useCouponByLoanLazyQuery();

    const { data: { loanApplication },loading } = useGetLoanQuery({
        variables:{
            id:loanApplicationId
        },
        fetchPolicy:"cache-first"
    });

    useEffect(() => {
        if(!loanApplicationId) {
            return null;
        }
    },[loanApplicationId])

    const loadDiscountsIfAvailable = async () => {
        if (loanApplication.couponCode) {
            const response = await couponByLoanQuery({
                variables:{
                    id: loanApplication.id
                }
            })


            if (response.data?.couponByLoan.discounts
                && hasDiscountsToApply(response.data?.couponByLoan.discounts, loanApplication)) {
                setDiscounts(response.data?.couponByLoan.discounts);
            }
        }
    }

    useEffect(() => {
        loadDiscountsIfAvailable();
    }, [loanApplication]);

    useEffect(() => {
        setDiscountCalculated(
            calculateDiscounts(discounts, loanApplication)
        );
    }, [discounts]);

    if (loading) {
        return (
            <Loading />
        );
    }

    return (
        <div className="summary-page">
            <Title>resumo da sua proposta</Title>

            <p className="grid-sub-title pb-5">
                Tudo certo, já estamos cuidando da sua proposta de crédito por aqui!
            </p>

            <LoanInfo
                loanApplication={{
                    ...loanApplication,
                    acceptedProposal: {
                        ...loanApplication?.acceptedProposal,
                        fixedComission: hasComissionDiscount(discounts, loanApplication) ? true : loanApplication?.acceptedProposal?.fixedComission,
                        interestRate: discountCalculated.calculatedInterestRate ? discountCalculated.calculatedInterestRate : loanApplication?.acceptedProposal?.interestRate,
                        paymentDay: discountCalculated.calculatedPaymentDay ? discountCalculated.calculatedPaymentDay : loanApplication?.acceptedProposal?.paymentDay
                    }
                }}
                discounts={discounts.filter(d => d.__typename === "ComissionDiscount")}
                canEdit={false}
            />

            <div className="grid-footer mt-5">
                <p>
                    Notou algo estranho com os dados?
                </p>
                <p className="pb-5">
                    Fala com a gente: <a href="mailto:faleconosco@bizcapital.com.br">faleconosco@bizcapital.com.br</a>
                </p>
            </div>
        </div>
    );
}

export default SummaryPage;
